import React, { useEffect } from 'react'
import {
	Avatar,
	Box,
	Drawer,
	drawerClasses,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Stack,
	Typography,
} from '@mui/material'
import WorkIcon from '@mui/icons-material/Work'
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import HelpRoundedIcon from '@mui/icons-material/HelpRounded'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ProfileMenu from '../components/ProfileMenu'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import StorageService, { StorageKeys } from '../services/StorageService'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import { logout } from '../store/slice/appSlice'

const mainListItems = [
	{ label: 'Поточні вакансії', icon: <WorkIcon />, path: '/vacancies' },
	{ label: 'Додати вакансію', icon: <NoteAddIcon />, path: '/add' },
	{
		label: 'Уточнення у кандидатів ',
		icon: <ChatBubbleIcon />,
		path: '/questions',
	},
]

const secondaryListItems = [
	{ label: 'Налаштування', icon: <SettingsRoundedIcon />, path: '/settings' },
	{ label: 'Про нас', icon: <InfoRoundedIcon />, path: '/about' },
	{ label: 'Зворотній зв\'язок', icon: <HelpRoundedIcon />, path: '/feedback' },
]

const MainLayout = () => {
	const location = useLocation()
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	return (
		<Box sx={{ display: 'flex' }}>
			<Drawer
				variant="permanent"
				sx={{
					width: 240,
					flexShrink: 0,
					height: '100%',
					boxSizing: 'border-box',
					mt: 10,
					[`& .${drawerClasses.paper}`]: {
						width: 240,
						boxSizing: 'border-box',
						backgroundColor: 'background.paper',
					},
				}}
			>
				<Box
					sx={{
						overflow: 'auto',
						height: '100%',
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
						<List dense>
							{mainListItems.map((item, index) => (
								<ListItem key={index} disablePadding sx={{ display: 'block' }}>
									<ListItemButton
										onClick={() => navigate(item.path)}
										selected={location.pathname.startsWith(item.path)}
									>
										<ListItemIcon>{item.icon}</ListItemIcon>
										<ListItemText primary={item.label} />
									</ListItemButton>
								</ListItem>
							))}
						</List>
						{/*<List dense>
							{secondaryListItems.map((item, index) => (
								<ListItem key={index} disablePadding sx={{ display: 'block' }}>
									<ListItemButton
										onClick={() => navigate(item.path)}
										selected={location.pathname.startsWith(item.path)}
									>
										<ListItemIcon>{item.icon}</ListItemIcon>
										<ListItemText primary={item.label} />
									</ListItemButton>
								</ListItem>
							))}
						</List>*/}
					</Stack>
				</Box>
				<Stack
					direction="row"
					sx={{
						p: 2,
						gap: 1,
						alignItems: 'center',
						borderTop: '1px solid',
						borderColor: 'divider',
					}}
				>
					<Avatar
						sizes="small"
						alt="Avatar"
						//src="/static/images/avatar/7.jpg"
						sx={{ width: 36, height: 36 }}
					>
						<AccountCircleIcon />
					</Avatar>
					<Box sx={{ mr: 'auto' }}>
						<Typography
							variant="body2"
							sx={{
								fontWeight: 500,
								lineHeight: '16px',
								maxWidth: '120px',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
							}}
						>
							{StorageService.getItem(StorageKeys.name) ?? 'Користувач'}
						</Typography>
					</Box>
					{/*<ProfileMenu />*/}
					<IconButton onClick={() => dispatch(logout())}>
						<LogoutRoundedIcon />
					</IconButton>
				</Stack>
			</Drawer>

			<Box
				bgcolor={'background.default'}
				sx={{ padding: '32px', width: '100%', minHeight: '100vh' }}
			>
				<Outlet />
			</Box>
		</Box>
	)
}

export default MainLayout
